import { render, staticRenderFns } from "./fraudplus-finalreport-page.vue?vue&type=template&id=37cad60d&scoped=true"
import script from "./fraudplus-finalreport-page.vue?vue&type=script&lang=js"
export * from "./fraudplus-finalreport-page.vue?vue&type=script&lang=js"
import style0 from "./fraudplus-finalreport-page.vue?vue&type=style&index=0&id=37cad60d&prod&lang=scss&module=true"
import style1 from "./fraudplus-finalreport-page.vue?vue&type=style&index=1&id=37cad60d&prod&lang=scss"
import style2 from "./fraudplus-finalreport-page.vue?vue&type=style&index=2&id=37cad60d&prod&lang=scss&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "37cad60d",
  null
  
)

export default component.exports